import { atom } from "recoil";

export const dataSearchList = atom({
  key: "dataSearchListHealth",
  default: {},
});
